// extracted by mini-css-extract-plugin
export default {"shake":"shake___fD4nK"};